import { render, staticRenderFns } from "./mediaPublishMulCoverUpload.vue?vue&type=template&id=4f1b503c&scoped=true&"
import script from "./mediaPublishMulCoverUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishMulCoverUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishMulCoverUpload.vue?vue&type=style&index=0&id=4f1b503c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b503c",
  null
  
)

component.options.__file = "mediaPublishMulCoverUpload.vue"
export default component.exports